import type { ReactNode } from "react";
import { AuthSessionProvider, type SignInReturnHandler } from "../core";
import { AuthErrorBoundary } from "../components";
import { AUTH_CONFIG } from "../config/auth.config";
import { registerTokenGetter, unregisterTokenGetter } from "../utils/tokenStore";

interface AuthProviderProps {
  children: ReactNode;
  /** Where the app goes after Auth0's callback; see SignInReturnHandler. */
  onSignInReturn: SignInReturnHandler;
}

export function AuthProvider({ children, onSignInReturn }: AuthProviderProps) {
  return (
    <AuthErrorBoundary>
      <AuthSessionProvider
        authEnabled={AUTH_CONFIG.enabled}
        onSignInReturn={onSignInReturn}
        registerTokenGetter={registerTokenGetter}
        unregisterTokenGetter={unregisterTokenGetter}
      >
        {children}
      </AuthSessionProvider>
    </AuthErrorBoundary>
  );
}
